import zhCNIcon from '../../asset/images/zh_cn_icon.svg';
import zhTwIcon from '../../asset/images/zh_tw_icon.svg';
import enGBIcon from '../../asset/images/en_gb_icon.svg';
import thTHIcon from '../../asset/images/th_th_icon.svg';

/**
 * 重要提示
 * 此处新增了语言类型，需要在 /src/helper/const/supportLanguage.js 中新增对应的语言类型
 * 同时在 src/root-application.js 中引入对应的react-intl资源，以及addLocaleData操作
 */
export const BrandLanguages = [
  {
    type: 'zh_CN', // 简体中文
    tip: '切换语言', // 切换语言的提示信息
    icon: zhCNIcon,
    name: '简体中文',
  },
  {
    type: 'zh_TW', // 繁体中文
    tip: '切換語言',
    icon: zhTwIcon,
    name: '繁體中文',
  },
  {
    type: 'en_GB', // 英文
    tip: 'Language',
    icon: enGBIcon,
    name: 'English',
  },
  {
    type: 'th_TH', // 泰语
    tip: 'เปลี่ยนภาษา',
    icon: thTHIcon,
    name: 'ไทย',
  },
];



// WEBPACK FOOTER //
// ./src/helper/const/languages.js